{
    "UsersByExtensions_ModalTitle": "Utilizadores",
    "UsersByExtensions_Filters": "Filtros",
    "UsersByExtensions_AllPartitions": "Todos os sítios",
    "UsersByExtensions_Header_Users": "Extensão - Nome completo",
    "UsersByExtensions_Header_MS_Licences": "Licenças MS",
    "UsersByExtensions_UserFields_Email": "Correio eletrónico",
    "UsersByExtensions_UserFields_Type": "Tipo de subscrição",
    "UsersByExtensions_UserFields_UseEmailAsUser": "Utilizar o e-mail como nome de utilizador",
    "UsersByExtensions_Username_Display_Title": "Nome de utilizador",
    "UsersByExtensions_Username_Display_Title_No_Username": "Sem nome de utilizador\n(Não é possível criar este utilizador)",
    "UsersByExtensions_UserFields_LegacyAppend": "{} (Legado)",
    "UsersByExtensions_UserType_Legacy_Akixi Lite": "Leve",
    "UsersByExtensions_UserType_Legacy_Akixi ONE": "UM",
    "UsersByExtensions_UserType_Legacy_Akixi BLF": "Presença",
    "UsersByExtensions_UserType_Legacy_Akixi 1000": "1000",
    "UsersByExtensions_UserType_Legacy_Akixi 2000": "2000",
    "UsersByExtensions_UserFields_Checkbox_Tooltip": "Criar\/atualizar utilizador",
    "UsersByExtensions_UserFields_Cross_Tooltip": "Eliminar utilizador",
    "UsersByExtension_UserType_NONE": "Monitorização desactivada (não licenciada)",
    "UsersByExtension_UserType_ESSENTIALS": "Essenciais",
    "UsersByExtension_UserType_ESSENTIALS_MST": "Norma CXA",
    "UsersByExtension_UserType_PROFESSIONAL": "Profissional",
    "UsersByExtension_UserType_PROFESSIONAL_MST": "CXA Premium",
    "UsersByExtension_UserType_ENTERPRISE": "Empresa",
    "UsersByExtension_UserType_ENTERPRISE_MST": "CXA Avançado",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT": "Agente do centro de atendimento",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_MST": "CXE Premium",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR": "Supervisor do centro de atendimento",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_MST": "CXE Avançado",
    "UsersByExtension_UserType_IsNotAgent": "Este utilizador tem um Agente se lhe der esta Subscrição, a atividade do Agente deixará de ser monitorizada",
    "UsersByExtension_UserType_IsNone": "A extensão associada a este utilizador deixará de ser monitorizada se lhe der esta subscrição",
    "UsersByExtension_Users_Multiple_Errors": "Existem vários utilizadores atribuídos a esta extensão: {}",
    "UsersByExtensions_ConfirmUserDelete": "Clique novamente para confirmar que pretende remover o acesso aos relatórios?",
    "UserByExtension_LicenceTypes_EV": "Licença EV",
    "UserByExtension_LicenceTypes_None": "Equipas Utilizador",
    "LicenceSummary_Title": "Resumo da licença",
    "LicenceSummary_Headers_Type": "Tipo",
    "LicenceSummary_Headers_InUse": "Em utilização",
    "LicenceSummary_Types_Essentials": "Essenciais",
    "LicenceSummary_Types_Essentials_MST": "Norma CXA",
    "LicenceSummary_Types_Professional": "Profissional",
    "LicenceSummary_Types_Professional_MST": "CXA Premium",
    "LicenceSummary_Types_Enterprise": "Empresa",
    "LicenceSummary_Types_Enterprise_MST": "CXA Avançado",
    "LicenceSummary_Types_Unlicenced": "Sem licença",
    "AddAllUsers_Button_Title": "Criar utilizadores para todas as extensões não monitorizadas",
    "AddAllUsers_Button_Title_Interpolated": "Criar {} utilizadores para todas as extensões não monitorizadas",
    "NoUsersAdded": "Não foram adicionados utilizadores",
    "TooManyUsers_NoLicences": "Não é possível adicionar {} utilizador porque não existem licenças disponíveis",
    "TooManyUsers_UsersPlural_LicenceNonPlural": "Não é possível adicionar {} utilizadores porque só está disponível {} licença",
    "TooManyUsers_UsersNonPlural_LicenceNonPlural": "Não é possível adicionar o utilizador {} porque só está disponível a licença {}",
    "TooManyUsers_NoLicences_Plural": "Não é possível adicionar {} utilizadores porque não existem licenças disponíveis",
    "TooManyUsers": "Não é possível adicionar {} utilizador porque só estão disponíveis {} licenças",
    "TooManyUsers_Plural": "Não é possível adicionar {} utilizadores porque só estão disponíveis {} licenças",
    "SuccessfullyAddedUsers": "Licenciou {} utilizadores com a licença \"{}\" com êxito",
    "AddAllUsers_PromptMessage": "Criar utilizadores para todas as extensões não monitorizadas com a licença \"{}\".\n\nTodas as alterações não guardadas serão perdidas. Tem a certeza de que pretende continuar?\n\n",
    "AddAllUsers_Confirm": "Confirmar",
    "AddAllUsers_Cancel": "Cancelar",
    "AddAllUsers_CreatingUsers": "Adicionar utilizadores com licença \"{}\"...",
    "AddAllUsers_Loading": "Carregando...",
    "NAME": "UsersByExtension",
    "UsersByExtensions_UserFields_CRM_Integration": "Integração CX",
    "UsersByExtension_CrmLicenceType_SOLO": "Integração Solo CRM",
    "UsersByExtension_CrmLicenceType_TEAMS": "Integração do Teams CRM",
    "UsersByExtension_CrmLicenceType_UNITE": "Integração CX",
    "UsersByExtension_CrmLicenceType_NONE": "Nenhuma integração de CRM",
    "LicenceSummary_Types_CallCentreAgent": "Agente de Call Center",
    "LicenceSummary_Types_CallCentreAgent_MST": "CXA Premium",
    "LicenceSummary_Types_CallCentreSupervisor": "Supervisor de Call Center",
    "LicenceSummary_Types_CallCentreSupervisor_MST": "CXA Avançado",
    "LicenceSummary_Types_CXIntegration": "Integração CX",
    "ProvisionAllCrm_Button_Title_Interpolated": "Criar\/atualizar usuários com licença {}",
    "ProvisionAllCrm_PromptMessage": "Crie usuários para todas as extensões não monitoradas com {}. \n \n Todas as alterações não salvas serão perdidas. Tem certeza de que deseja continuar? \n \n",
    "TooManyUsers_MaxTelSysCapReached": "Não é possível adicionar {} usuários, pois isso excederia o número máximo de usuários permitidos pelo sistema telefônico",
    "TooManyUsers_MaxTelSysCapReached_Plural": "Não é possível adicionar {} usuários, pois isso excederia o número máximo de usuários permitido pelo sistema telefônico"
}